import {
  FORM_TYPE,
  type FormRef,
  onProfileUpdateSubmit,
} from '@atlas/react-forms';
import { type FC, useCallback, useRef, useState } from 'react';

import { clientProfileUpdate } from 'api/clientProfile';
import { activeFormsRequest } from 'api/forms';
import { Form } from 'components/Form';
import Loader from 'components/Loader';
import Meta from 'components/Meta';
import { useClientProfile, useNotifications } from 'store';
import { Translation, useTranslation } from 'utils/translations';

import styles from './AccountInformation.module.scss';

const AccountInformation: FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [{ add }] = useNotifications();
  const [{ sessionToken }] = useClientProfile();
  const messageSuccess = useTranslation('update_profile_success_message');
  const formRef = useRef<FormRef>(null);

  const getActiveForms = useCallback(() => {
    return activeFormsRequest({
      query: {
        formType: FORM_TYPE.PROFILE_UPDATE,
      },
      headers: {
        authorization: `Bearer ${sessionToken}`,
      },
    });
  }, [sessionToken]);

  const handleSubmit = onProfileUpdateSubmit(async (values) => {
    setIsLoading(true);

    const { id, ...rest } = values;

    try {
      await clientProfileUpdate({
        body: {
          id: Number(id),
          values: rest,
        },
        headers: {
          authorization: `Bearer ${sessionToken}`,
        },
      });
      add({
        text: messageSuccess,
      });
    } catch (error) {
      // @ts-ignore
      formRef.current.setGlobalErrors([error.code]);
    } finally {
      setIsLoading(false);
    }
  });

  return (
    <div className={styles['account-information-form-container']}>
      <Meta title={<Translation message="title_account_information" />} />
      <Form
        ref={formRef}
        formType={FORM_TYPE.PROFILE_UPDATE}
        // @ts-ignore
        handleSubmit={handleSubmit}
        onError={() => setIsLoading(false)}
        beforeSubmitButton={isLoading && <Loader />}
        getActiveForms={getActiveForms}
        submitButtonText="save_button"
      />
    </div>
  );
};

export default AccountInformation;
